import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle Linien'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Linien)'},
  {key: FILTER_NONE, label: 'Keine Linien'},
];
